import { Component, Input, OnChanges, SimpleChanges,AfterViewInit, ViewChild, OnInit } from '@angular/core';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { HttpClient } from '@angular/common/http';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { SseService } from 'src/app/services/SseService';


/* interface historico {
  adjClose: number;
  change: number;
  changeOverTime: number;
  changePercent: number;
  close: number;
  date: string;
  high: number;
  label: string;
  low: number;
  open: number;
  unadjustedVolume: number;
  volume: number;
  vwap: number;
} */

@Component({
  selector: 'app-datos-historicos',
  templateUrl: './datos-historicos.component.html',
  styleUrl: './datos-historicos.component.scss'
})
export class DatosHistoricosComponent implements OnChanges, OnInit {
  @Input() compania: string = '';
  @Input() selectedTab: number=0;
  @Input() descripcion: any;
  public iso='';
  datasource2 = new TableVirtualScrollDataSource<any>();
  displayedColumns2 = ['date', 'open','high','low','close','volume'];
  @ViewChild(CdkVirtualScrollViewport, { static: false })  datosHistoricos!: CdkVirtualScrollViewport;



  constructor(private _liveAnnouncer: LiveAnnouncer,
              private _apiSseService: SseService,
  ) {}
  ngOnInit(){
    this.actualizarViewport();
  }

  ngOnChanges(changes: SimpleChanges) {

    if(changes['compania']){
      
      this.cargarData();
    }else if(changes['selectedTab']){
      this.actualizarViewport();
    }

  }

  cargarData(){

    let url='v3/historical-price-full/'+this.compania+'?from=1990-01-01';
    if(this.compania){
      this._apiSseService.apiGetNew(url).subscribe({
        next: (data: any)=>{
          this.datasource2.data=data.historical;
        }
      });
    }
  }
  actualizarViewport() {

    if (this.datosHistoricos) {
      this.datosHistoricos.checkViewportSize();
      this.datosHistoricos.checkViewportSize();
    }
  }

}
